(() => {
  const root = document.querySelector('[data-afd-page]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const slides = Array.from(root.querySelectorAll('[data-afd-slide]'));
  const thumbs = Array.from(root.querySelectorAll('[data-afd-thumb]'));
  let index = 0;
  const showSlide = (nextIndex) => {
    if (!slides.length) return;
    index = (nextIndex + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
    thumbs.forEach((thumb, thumbIndex) => {
      const active = thumbIndex === index;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
      if (active) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    });
  };
  root.querySelector('[data-afd-prev]')?.addEventListener('click', () => showSlide(index - 1));
  root.querySelector('[data-afd-next]')?.addEventListener('click', () => showSlide(index + 1));
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => showSlide(Number(thumb.dataset.afdThumb))));

  const form = root.querySelector('#airfry-duo-form');
  const button = root.querySelector('[data-afd-atc]');
  if (!form || !button) return;
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (button.disabled || button.dataset.submitting === 'true') return;
    const id = form.querySelector('[data-afd-variant-id]')?.value;
    if (!id) return;
    button.dataset.submitting = 'true';
    button.classList.add('is-loading');
    document.dispatchEvent(new CustomEvent('cart:add', {
      detail: {
        source: 'airfry-duo-product',
        items: [{ id: Number(id), quantity: 1 }],
        onSuccess: () => {
          button.dataset.submitting = 'false';
          button.classList.remove('is-loading');
        },
        onError: () => {
          button.dataset.submitting = 'false';
          button.classList.remove('is-loading');
        }
      }
    }));
  });
})();
